<div class="trust_container" *ngIf="isNotPrivateSiteowner$ | async">
  <ng-container i18n="@@footer.secure_buy_at">SICHER KAUFEN BEI</ng-container>
  <img
    class="brand"
    alt="trust-seal"
    [attr.data-e2e]="'trust-seal'"
    [src]="'brand/' + this.staticBrand + '/logo/logo_wide.svg' | orderformAsset"
  />
</div>

<div [attr.data-e2e]="'form:footer'" class="footer-container">
  <div>
    <a
      *ngFor="let item of footerMenuItems$ | async; trackBy: trackByLabel"
      class="footer-item"
      [attr.id]="item.id"
      (click)="openModal(item)"
    >
      {{ item.label }}
    </a>
  </div>

  <div class="copyright-hint" i18n="@@form_footer.copyright_with_dyn_brand">
    &copy; {{ year }} {{ reseller$ | async }}, alle Rechte vorbehalten
  </div>

  <div class="affiliate">
    [
    <ng-container *ngIf="affiliate$ | async as affiliate; else noAffiliate">{{ affiliate }}</ng-container>
    <ng-template #noAffiliate>
      <ng-container i18n="@@form_footer.is_no_affiliate">none </ng-container>
    </ng-template>
    ]
  </div>
</div>
